import { compose, prop, path } from "ramda";
import { createSelector } from "reselect";
import * as model from "./model";

export const scopeSelector = state => state.modules.user.auth;

export const getToken = compose(prop("token"), scopeSelector);
export const isAuthenticated = compose(Boolean, getToken);
export const signInApi = compose(path(["api", "signIn"]), scopeSelector);
export const linkedInSignInApi = compose(
  path(["api", "linkedInSignIn"]),
  scopeSelector
);
export const signUpApi = compose(path(["api", "signUp"]), scopeSelector);
export const insiderSignUpApi = compose(
  path(["api", "InsiderSignUp"]),
  scopeSelector
);

export const resetPasswordApi = compose(
  path(["api", "resetPassword"]),
  scopeSelector
);
export const setPasswordApi = compose(
  path(["api", "setPassword"]),
  scopeSelector
);
export const fetchUserDataApi = compose(
  path(["api", "fetchUserData"]),
  scopeSelector
);

export const getDiscountInfoApi = compose(
  path(["api", "getDiscountInfo"]),
  scopeSelector
);

export const checkUserDiscountApi = compose(
  path(["api", "checkUserDiscount"]),
  scopeSelector
);

export const checkUserDiscount = createSelector(
  [checkUserDiscountApi],
  api => api.data
);

export const fetchUserData = createSelector(
  [fetchUserDataApi],
  api => api.data && model.getUserData(api.data)
);



// WEBPACK FOOTER //
// ./src/modules/user/auth/selectors.js